module.exports = __webpack_public_path__ + "static/media/FrownCryingFace.844f6d29.svg";